/**
 * Qué picker mostrar para un campo migrado al maestro de lugares: el nativo
 * del vertical (catálogo propio) o `PlaceAutocomplete` (#2170). Compartida
 * por TODOS los verticales del epic #2167 — 21.22: una sola definición, no
 * una copia por vertical que pueda desalinearse (si un caso borde de esta
 * regla resulta estar mal, arreglarlo acá lo arregla para todos a la vez).
 *
 * Una vez que hay ALGO elegido en un modo — venga de tipear o de
 * reconstruir la URL/un reciente — ese modo queda FIJO por el resto de la
 * sesión: nunca se swapea el picker por debajo de una selección ya hecha.
 * Cubre las DOS direcciones de la carrera con `usePlacesEnabled()`:
 * - El setting resuelve DESPUÉS del primer render (carga async): sin esto,
 *   un asesor que ya eligió en el nativo mientras cargaba vería su
 *   selección desaparecer en cuanto el setting confirmara `true`.
 * - El setting cambia en caliente (`refetchOnWindowFocus` en
 *   `useGetSettingsByAgencyId`): un toggle de un admin en otra pestaña no
 *   puede voltear el picker debajo de un formulario que el asesor ya
 *   completó.
 *
 * Sin ninguna selección todavía, sigue al valor VIVO del setting — así,
 * apenas resuelve, aparece el picker correcto sin que el asesor haya hecho
 * nada que perder.
 */
export function resolvePlacesPickerMode({
  settingEnabled,
  hasNativeSelection,
  hasPlaceSelection,
}: {
  settingEnabled: boolean;
  hasNativeSelection: boolean;
  hasPlaceSelection: boolean;
}): boolean {
  if (hasNativeSelection) return false;
  if (hasPlaceSelection) return true;
  return settingEnabled;
}
